import { searchAppointments } from "@/api/appointment.service";

export const useAppointmentSearch = () => {
  const itemTitle = i => {
    if (!i?.id) return null;
    return `${i.ownableName} · ${i.name} · Status: ${i.status}`;
  };
  return {
    itemTitle,
    comparisonValue: v => v.id,
    fetchResults: async (search, searchArgs) => {
      const response = await searchAppointments(
        searchArgs.appointmentId,
        search
      );
      return response.toSorted((a, b) =>
        itemTitle(a).localeCompare(itemTitle(b))
      );
    }
  };
};
